
const ProductType = {
    PLAN: 'plan',
    ADD_ON: 'addOn',
    ACCESS_PLAN_DEFAULT_PRODUCTID: 'access_plan'
};

const APPORTIONMENT_AVERAGE_MONTH_DAYS = 30;

const SubscriptionStatus = {
    ONGOING: 'ONGOING', // previously was RENEWED
    PENDING_COMPLETION: 'PENDING_COMPLETION', // previously was PENDING_CANCEL
    REVOKED: 'REVOKED', // previously was CANCELED,
    EXPIRED: 'EXPIRED'
};

const SubscriptionStatusMotorplayStripe = {
    CANCELED: 'canceled',
    ACTIVE: 'active'
};

const SubscriptionStatusMotorplayMercadoPago = {
    CANCELED: 'canceled',
    AUTHORIZED: 'authorized'
};

const PaymentMethods = {
    ACCESS: "access",
    AFFILIATES: "affiliates"
}

const RulesType = {
    PURCHASE: 'purchase',
    ADDITIONAL_PURCHASE: 'additionalPurchase'
};

const RulesName = {
    UPGRADEABLE_TO: 'upgradeableTo',
    DOWNGRADEABLE_TO: 'downgradeableTo',
    INCOMPATIBLE_OFFERINGS: 'incompatibleOfferings',
    INCOMPATIBLE_ADDONS: 'incompatibleAddOns',
    PLAN_ADDONS_OFFERING: 'addOnsOffering',
    PLAN_INCLUDE_ADDONS: 'includedAddOns'
};

const SalePriceTypes = {
    OFFER_PRICE: 'offerPrice',
    DISCOUNT: 'discount'
};

const ModalPaymentMethodsType = {
    NEW_PAYMENT_METHOD: 'newPaymentMethod',
    FORCE_TO_CHANGE_FAVORITE: 'forceToChangeToFavorite',

};

const InvoiceType = {
    INVOICE: 'invoice',
    RECEIPT: 'receipt'
};

const RecurrenceIntervalsInDays = {
    day: 1,
    week: 7,
    month: 30,
    year: 365,
}

const priceFormats = {
    "CL": {
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "vatPercentage": 19,
        "currency": "$"
    },
    "MX": {
        "decimalSeparator": ".",
        "thousandsSeparator": ",",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "vatPercentage": 16,
        "currency": "$"
    },
    "AR": {
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en pesos argentinos",
        "vatPercentage": 21,
        "currency": "$"
    },
    "CO": {
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "vatPercentage": 19,
        "currency": "$"
    },
    "BR": {
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "decimalPlaces": 2,
        "formattedCurrency": "Preços expressos em dólares",
        "vatPercentage": 17,
        "currency": "R$"
    },
    "EC": {
        "decimalSeparator": ".",
        "thousandsSeparator": ",",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "vatPercentage": 15,
        "currency": "$"
    },
    "PE": {
        "decimalSeparator": ".",
        "thousandsSeparator": ",",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "currency": "$"
    },
    "UY": {
        "decimalSeparator": ",",
        "thousandsSeparator": ".",
        "decimalPlaces": 2,
        "formattedCurrency": "Precios expresados en dólares",
        "vatPercentage": 22,
        "currency": "$"
    },
};

const PaymentGateways = {
    dlocal: 'dlocal',
    stripe: 'stripe',
    mercadopago: 'mercadopago',
    freepass: 'freepass',
    affiliates: 'affiliates',
}

const PurchaseStates = {
    UNPAID: "UNPAID",
    PAID_OFF: "PAID_OFF"
}
// en, es, pt
const EssentialKeyWords = ["essential", "esencial", "essencial"];
const hideNewPaymentMethod = ["AR"];

module.exports = {
    ProductType,
    RulesType,
    RulesName,
    SubscriptionStatus,
    APPORTIONMENT_AVERAGE_MONTH_DAYS,
    SalePriceTypes,
    PaymentMethods,
    ModalPaymentMethodsType,
    InvoiceType,
    RecurrenceIntervalsInDays,
    priceFormats,
    PaymentGateways,
    EssentialKeyWords,
    SubscriptionStatusMotorplayStripe,
    SubscriptionStatusMotorplayMercadoPago,
    hideNewPaymentMethod,
    PurchaseStates
};
